"use client";

import { c as _c } from "react/compiler-runtime";
import { Menu, X } from "lucide-react";
import Link from "next/link";
import { useState } from "react";
import { ThemeToggle } from "@/components/landing/theme-toggle";
import { ProviderPromoBanner } from "@/components/ProviderPromoBanner";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/ui/logo";
import { useUser } from "@/hooks/useUser";
import { useAppConfig } from "@/lib/config";
export function Header() {
  const $ = _c(36);
  const config = useAppConfig();
  const {
    user,
    isLoading
  } = useUser();
  const isAuthenticated = !!user && !isLoading;
  const [menuOpen, setMenuOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ProviderPromoBanner />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Link href="/" className="flex items-center gap-2"><div className="flex h-7 w-7 items-center justify-center rounded-lg bg-foreground text-background"><Logo className="h-4 w-4" /></div><span className="font-semibold text-lg">DevPass</span></Link>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== config.uiUrl) {
    t2 = <div className="flex items-center gap-2">{t1}<a href={config.uiUrl} target="_blank" rel="noopener noreferrer" className="text-xs text-muted-foreground hover:text-foreground transition-colors">by LLM Gateway</a></div>;
    $[2] = config.uiUrl;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Button variant="ghost" size="sm" asChild={true}><Link href="/coding-models">Models</Link></Button>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Button variant="ghost" size="sm" asChild={true}><Link href="/guides">Guides</Link></Button>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Button variant="ghost" size="sm" asChild={true}><Link href="/pricing">Pricing</Link></Button>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Button variant="ghost" size="sm" asChild={true}><Link href="/compare">Compare</Link></Button>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Button variant="ghost" size="sm" asChild={true}><Link href="/leaderboard">Leaderboard</Link></Button>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== config.docsUrl) {
    t8 = <Button variant="ghost" size="sm" asChild={true}><a href={config.docsUrl} target="_blank" rel="noopener noreferrer">Docs</a></Button>;
    $[9] = config.docsUrl;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ThemeToggle size="compact" />;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== isAuthenticated) {
    t10 = isAuthenticated ? <Button size="sm" asChild={true}><Link href="/dashboard">Dashboard</Link></Button> : <><Button variant="ghost" size="sm" asChild={true}><Link href="/login">Sign in</Link></Button><Button size="sm" asChild={true}><Link href="/signup">Get Started</Link></Button></>;
    $[12] = isAuthenticated;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t8) {
    t11 = <div className="hidden sm:flex items-center gap-3">{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}</div>;
    $[14] = t10;
    $[15] = t8;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== menuOpen) {
    t12 = () => setMenuOpen(!menuOpen);
    $[17] = menuOpen;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const t13 = menuOpen ? "Close menu" : "Open menu";
  let t14;
  if ($[19] !== menuOpen) {
    t14 = menuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />;
    $[19] = menuOpen;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t12 || $[22] !== t13 || $[23] !== t14) {
    t15 = <button type="button" onClick={t12} className="sm:hidden p-2 -mr-2" aria-label={t13}>{t14}</button>;
    $[21] = t12;
    $[22] = t13;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t11 || $[26] !== t15 || $[27] !== t2) {
    t16 = <div className="container mx-auto px-4 py-4 flex items-center justify-between">{t2}{t11}{t15}</div>;
    $[25] = t11;
    $[26] = t15;
    $[27] = t2;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== config.docsUrl || $[30] !== isAuthenticated || $[31] !== menuOpen) {
    t17 = menuOpen && <div className="sm:hidden border-t border-border/50 px-4 py-4 space-y-3"><Link href="/coding-models" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setMenuOpen(false)}>Models</Link><Link href="/guides" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setMenuOpen(false)}>Guides</Link><Link href="/pricing" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setMenuOpen(false)}>Pricing</Link><Link href="/compare" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setMenuOpen(false)}>Compare</Link><Link href="/leaderboard" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setMenuOpen(false)}>Leaderboard</Link><a href={config.docsUrl} target="_blank" rel="noopener noreferrer" className="block text-sm text-muted-foreground hover:text-foreground transition-colors">Docs</a><ThemeToggle size="compact" />{isAuthenticated ? <Button size="sm" className="w-full" asChild={true}><Link href="/dashboard" onClick={() => setMenuOpen(false)}>Dashboard</Link></Button> : <><Link href="/login" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setMenuOpen(false)}>Sign in</Link><Button size="sm" className="w-full" asChild={true}><Link href="/signup" onClick={() => setMenuOpen(false)}>Get Started</Link></Button></>}</div>;
    $[29] = config.docsUrl;
    $[30] = isAuthenticated;
    $[31] = menuOpen;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t16 || $[34] !== t17) {
    t18 = <header className="border-b border-border/50">{t0}{t16}{t17}</header>;
    $[33] = t16;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  return t18;
}